import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";

import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { InputLabel, MenuItem, Select } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { createWash } from "../../State/Wash/Action";
import MultipleSelect from "../Tools/MultipleSelect";
import { getWorkers } from "../../State/Worker/Action";
import moment from "moment";
import DateTimeDropDown from "../Tools/DateTimeDropDown";
import {
  DEFAULT_WASH_TYPE,
  VEHICLE_WASH_TYPE_OPTIONS,
  WASH_TYPE_LABELS,
  extractSeaterFromWashType,
  extractWashCode,
  formatWashTypeKey,
} from "../../constants/washTypes";

export default function CreateWashDialog({
  bookingId,
  vehicle,
  washType,
  bookingAt,
  seater,
}) {
  const [open, setOpen] = React.useState(false);
  const [startedAt, setStartedAt] = React.useState(
    moment(new Date(bookingAt)).format("yyyy-MM-DD HH:mm:ss.SSS")
  );
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = React.useState("");
  const [successMessage, setSuccessMessage] = React.useState("");
  const { worker } = useSelector((store) => store);
  const [workerIds, setWorkerIds] = React.useState([]);
  const initialSeater =
    seater ||
    extractSeaterFromWashType(washType) ||
    (vehicle === "CAR" ? "FIVE_SEATER" : "TWO_SEATER");
  const [seaterType, setSeater] = React.useState(initialSeater);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    dispatch(getWorkers());
  }, [dispatch]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");
    const formData = new FormData(event.target);
    const type =
      formData.get("washType") ||
      VEHICLE_WASH_TYPE_OPTIONS[vehicle]?.[0] ||
      DEFAULT_WASH_TYPE;
    const wash = {
      remarks: formData.get("remarks"),
      startedAt: `${startedAt}`,
      washType: formatWashTypeKey(type, vehicle),
      vehicle,
      vehicleType: vehicle,
      workerIds,
      seater: seaterType,
    };
    console.log(wash);
    if (workerIds.length === 0) {
      setErrorMessage("Please select worker");
      return;
    }
    const inputRequest = {
      bookingId,
      wash,
      setSuccessMessage,
      setErrorMessage,
    };
    dispatch(createWash(inputRequest));
  };

  return (
    <React.Fragment>
      <Button variant="outlined" onClick={handleClickOpen}>
        Create Wash
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle className="text-center font-bold text-green-700">
          Create Wash
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <form onSubmit={handleSubmit}>
              <div>
                <div>
                  <div className="mt-2 mb-2">
                    <span>
                      Vehicle: <strong>{vehicle}</strong>
                    </span>
                  </div>
                  <div className="mt-2 mb-2">
                    <InputLabel id="wash-label">Wash type</InputLabel>
                    <Select
                      labelId="wash-select-label"
                      id="wash-select"
                      //   value={age}
                      label="WashType"
                      defaultValue={
                        VEHICLE_WASH_TYPE_OPTIONS[vehicle]?.includes(
                          extractWashCode(washType)
                        )
                          ? extractWashCode(washType)
                          : VEHICLE_WASH_TYPE_OPTIONS[vehicle]?.[0] ||
                            DEFAULT_WASH_TYPE
                      }
                      name="washType"
                    >
                      {VEHICLE_WASH_TYPE_OPTIONS[vehicle]?.map((type) => (
                        <MenuItem key={type} value={type}>
                          {WASH_TYPE_LABELS[type] || type}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <div className="mt-2 mb-2">
                    <MultipleSelect
                      objectMap={worker?.workers}
                      setIds={setWorkerIds}
                    />
                  </div>

                  {vehicle === "CAR" && (
                    <div className="mt-2 mb-2">
                      <InputLabel id="seater-label">Seater</InputLabel>
                      <Select
                        labelId="seater-select-label"
                        id="seater-select"
                        //   value={age}
                        label="WashType"
                        defaultValue={seaterType}
                        onChange={(e) => setSeater(e.target.value)}
                        name="seaterType"
                      >
                        <MenuItem value="FIVE_SEATER">5 Seater</MenuItem>
                        <MenuItem value="SIX_SEVEN_SEATER">6-7 Seater</MenuItem>
                        <MenuItem value="EIGHT_AND_MORE_SEATER">
                          8+ Seater
                        </MenuItem>
                      </Select>
                    </div>
                  )}

                  <div className="mt-2 mb-2">
                    <DateTimeDropDown setDateTime={setStartedAt} delay={-8} />
                  </div>
                  <div className="mt-2 mb-2">
                    <TextField
                      multiline
                      rows={4}
                      variant="outlined"
                      autoFocus
                      required
                      margin="dense"
                      id="remarks"
                      name="remarks"
                      label="Remarks"
                      type="text"
                      fullWidth
                      defaultValue=""
                    />
                  </div>
                </div>
              </div>
              <Button type="submit">Update</Button>
              <Button onClick={handleClose}>Cancel</Button>
              <div>
                {successMessage.length > 0 && (
                  <span className="text-green-700">{successMessage}</span>
                )}
              </div>
              <div>
                {errorMessage.length > 0 && (
                  <span className="text-red-700">{errorMessage}</span>
                )}
              </div>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
